export default __webpack_public_path__ + "static/media/bronzeBadge.57c69fc0.svg";